module.exports = __webpack_public_path__ + "static/media/cancelado.f3fde0cd.png";